<style src="./ContextFieldCompare.scss" lang="scss"></style>
<template>
  <section class="text-filter">
    <form @submit.prevent="sendFilter" class="rowsection">
      <span class="filtertitle">Filtro por Coparação</span>
      <div class="filters">
        <form
          @submit.prevent
          class="form">
          <label class="option">
            
            <input
              type="checkbox"
              value="cmedgteestimated"
              v-model="filters.filterValue">
            <span class="avaliable">CMED <strong>maior</strong> ESTIMADO</span>
          </label>
          <label class="option">
            <input
              type="checkbox"
              value="cmedlteestimated"
              v-model="filters.filterValue">
            <span class="avaliable">CMED <strong>menor</strong> ESTIMADO</span>
          </label>
        </form>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: 'ContextFieldCompare',
  props: {
    columnId: {
      default: null
    }
  },
  data: () => ({
    filters: {
      filterValue: ['cmedlteestimated', 'cmedgteestimated']
    }
  }),
  watch: {
    'filters.filterValue' (v, o) {
      if (v.length === o.length) {
        return
      }
      if (v.length === 0 || v.length === 2) {
        this.filters.filterValue = ['cmedlteestimated', 'cmedgteestimated']
        this.sendEvent('0')
        return
      }
      this.sendEvent('fieldCompare')
    }
  },
  methods: {
    sendEvent (filterType) {
      const filter = {
        columnId: this.columnId,
        filterType,
        filterValue: this.filters.filterValue
      }
      this.$emit('filter-value', filter)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-field-compare/ContextFieldCompare.vue